export type CommsTraceEndState = 'sent' | 'failed' | 'unknown';

export type CommsTraceStageKey =
  | 'relevance_filter'
  | 'prefilter'
  | 'similarity_check'
  | 'xco'
  | 'hedwig_delivery';

export type CommsTraceStoppedAt = CommsTraceStageKey;

export interface CommsTraceCampaign {
  id: string;
  name: string;
  is_trident: number;
  channel: string;
  is_attributepairing: number;
  xco_enabled: number;
  country_id: number;
}

export interface CommsTraceHedwigComponent {
  channel: string;
  status: string;
  message_id: string;
  category: string;
  callingservice: string;
  status_title: string;
  status_details: string;
  title: string;
  content: string;
  send_mode: string;
  event_time: string;
}

export interface CommsTraceXcoAttempt {
  dispatch_date: string;
  status: string;
  event_time?: string | null;
}

export interface CommsTraceStages {
  relevance_filter: {
    status: string;
    score: number;
    event_time?: string | null;
    dispatch_time?: string | null;
    submission_date?: string | null;
    channel?: string | null;
  } | null;
  prefilter: { status: string; reason: string; event_time?: string | null } | null;
  similarity_check: {
    status: string;
    original_score: number;
    final_score: number;
    event_time?: string | null;
  } | null;
  xco: {
    status: string;
    attempts: CommsTraceXcoAttempt[];
  } | null;
  hedwig_delivery: {
    status: string;
    event_time?: string | null;
    channel?: string | null;
    components: CommsTraceHedwigComponent[];
  } | null;
}

export interface CommsTraceJourney {
  user_id: string;
  user_type: string;
  tracking_id: string | null;
  template_id: string;
  campaign: CommsTraceCampaign | null;
  sent_time: string | null;
  end_state: CommsTraceEndState;
  stopped_at: CommsTraceStoppedAt | null;
  reason: string | null;
  stages: CommsTraceStages;
}

export interface CommsTraceUserResult {
  total: number;
  truncated: boolean;
  journeys: CommsTraceJourney[];
}

export interface GetCommsTraceResponse {
  timezone: string;
  start_time: string;
  end_time: string;
  users: Record<string, CommsTraceUserResult>;
  page: number;
  pageSize: number;
}

export const MAX_USER_IDS = 20;
export const MAX_RANGE_DAYS = 31;
export const MAX_RANGE_MS = MAX_RANGE_DAYS * 24 * 3600 * 1000;
export const COMMS_TRACE_STAGE_KEYS: CommsTraceStageKey[] = [
  'relevance_filter',
  'prefilter',
  'similarity_check',
  'xco',
  'hedwig_delivery',
];
